module.exports = __webpack_public_path__ + "img/SES_242410001.423e2b2f.jpg";